import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ResourceForm from '@panneau/form-resource';
import { useResourceValues } from '@panneau/intl';
import Dialog from '@panneau/modal-dialog';

var propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  resource: PropTypes.string,
  type: PropTypes.string,
  item: PropTypes.shape({
    id: PropTypes.string
  }),
  isCreate: PropTypes.bool,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  resource: null,
  type: null,
  item: null,
  isCreate: null,
  onSuccess: null,
  onClose: null,
  className: null
};
var ModalResourceForm = function ModalResourceForm(_ref) {
  var id = _ref.id,
    resource = _ref.resource,
    type = _ref.type,
    item = _ref.item,
    isCreate = _ref.isCreate,
    onSuccess = _ref.onSuccess,
    onClose = _ref.onClose,
    className = _ref.className;
  var resourceValues = useResourceValues(resource);
  return /*#__PURE__*/React.createElement(Dialog, {
    id: id,
    title: !isCreate !== null ? /*#__PURE__*/React.createElement(FormattedMessage, {
      values: resourceValues,
      id: "mCfzkJ",
      defaultMessage: [{
        "type": 0,
        "value": "Edit "
      }, {
        "type": 1,
        "value": "a_singular"
      }]
    }) : /*#__PURE__*/React.createElement(FormattedMessage, {
      values: resourceValues,
      id: "6viUpq",
      defaultMessage: [{
        "type": 0,
        "value": "Create "
      }, {
        "type": 1,
        "value": "a_singular"
      }]
    }),
    size: "lg",
    onClose: onClose,
    className: className
  }, /*#__PURE__*/React.createElement(ResourceForm, {
    resource: resource,
    type: type,
    item: item,
    onSuccess: onSuccess
  }));
};
ModalResourceForm.propTypes = propTypes;
ModalResourceForm.defaultProps = defaultProps;

export { ModalResourceForm as default };
